"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const metricsData = [{
  value: 500,
  suffix: "+",
  label: "Manuscript Pages"
}, {
  value: 12,
  suffix: "",
  label: "Global Locations"
}, {
  value: 1,
  suffix: "",
  label: "Cinematic Short Film"
}, {
  value: 100,
  suffix: "%",
  label: "Mission Success"
}];
function AnimatedCounter({
  value,
  suffix,
  label
}: {
  value: number;
  suffix: string;
  label: string;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.5
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let startTime: number;
    const duration = 2500;
    const step = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const easeProgress = 1 - Math.pow(1 - progress, 4);
      setCount(Math.floor(easeProgress * value));
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        setCount(value);
      }
    };
    window.requestAnimationFrame(step);
  }, [isVisible, value]);
  return <div data-section-id="152770" ref={ref} className="flex flex-col items-center justify-center text-center space-y-4 border-b border-primary/30 pb-6">
      <div className="text-5xl md:text-6xl lg:text-7xl font-sans text-primary tracking-widest drop-shadow-[0_0_12px_rgba(6,182,212,0.6)]">
        {count}
        <span className="text-primary/60">{suffix}</span>
      </div>
      <div className="text-xs md:text-sm uppercase tracking-widest font-mono text-muted-foreground font-medium">
        {label}
      </div>
    </div>;
}
export default function StudioMetrics() {
  return <section id="project-statistics" className="dark bg-background text-foreground">
      <div className="w-full bg-accent/5 border-y border-primary/20 py-20 md:py-32 relative overflow-hidden">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-8">
            {metricsData.map((metric, i) => <div key={i} data-index={i}>
                <AnimatedCounter {...metric} />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}